import React, { useEffect } from "react";
import HeroSection from "./HeroSection";
import ProductDetails from "./ProductDetails";
import Benefits from "./Benefits";
import FAQSection from "./FAQSection";
import main from "../assets/monkeySeaftynets.jpg";
import img1 from "../assets/monkey/1.jpg";
import img2 from "../assets/monkey/2.jpg";
import img3 from "../assets/monkey/3.jpg";

import Images from "./Images";
import { Helmet } from "react-helmet-async";

export default function MonkeySafetyNets() {
       useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "Monkey Safety Nets Bengaluru call now 7416116587 S",
    url: "https://www.anssafetynets.com/monkeysafetynets",
    description:
      "Installing monkey safety nets on a balcony is a practical way to prevent monkeys from entering your home or damaging property, especially in areas where monkey presence is common.",
    keywords: [
  "cricket practice nets installation",
  "sports netting installation services",
  "indoor cricket nets",
  "outdoor sports nets",
  "affordable cricket net installation for schools",
  "durable sports nets for academies",
  "cricket net installation in Bengaluru",
  "cricket net installation in Bangalore",
  "sports nets near me",
  "custom sports nets Bengaluru",
  "outdoor cricket practice nets"
],
    breadcrumb: {
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.anssafetynets.com",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Monkey Safety Nets",
          item: "https://www.anssafetynets.com/monkeysafetynets",
        },
      ],
    },
    publisher: {
      "@type": "Organization",
      name: "ANS Safety Nets",
      logo: {
        "@type": "ImageObject",
        url: "https://www.anssafetynets.com/logo.png",
        width: 250,
        height: 100,
      },
      contactPoint: [
        {
          "@type": "ContactPoint",
          telephone: "+91-7416116587",
          contactType: "Customer Service",
          areaServed: "IN",
          availableLanguage: ["English", "Kannada"],
        },
      ],
      sameAs: [
        "https://www.facebook.com/profile.php?id=61572534324956",
        "https://www.instagram.com/anssafetynets_bengaluru/",
      ],
    },
    mainEntity: {
      "@type": "Organization",
      name: "ANS Safety Nets",
      address: {
        "@type": "PostalAddress",
        streetAddress:
          "74/9, 5th Cross Rd, Muthyala Nagar, Bahubali Nagar, Jalahalli, Bengaluru, Karnataka 560013",
        addressLocality: "Bengaluru",
        addressRegion: "KA",
        postalCode: "560013",
        addressCountry: "IN",
      },
      service: [
        {
          "@type": "Service",
          name: "Monkey Safety Nets",
          areaServed: "Bengaluru",
        },
      ],
    },
  };
  return (
    <div>
      <Helmet>
        <title>Monkey Safety Nets Bengaluru call now 7416116587 S</title>
        <meta
          name="description"
          content="Installing monkey safety nets on a balcony is a practical way to prevent monkeys from entering your
home or damaging property, especially in areas where monkey presence is common."
        />
        <meta
          name="keywords"
          content="Monkey safety net
Balcony monkey net
Monkey protection net
Anti-monkey net for balcony
Monkey control net
HDPE monkey ne
Monkey barrier net
Balcony safety net for monkeys
Monkey repellent net installation
Monkey-proof balcony net
Animal safety nets
Residential monkey nets
Terrace top net 
Terrace top monkey nets Bengaluru 
Terrace safety nets bangalore"
        />
        <meta name="author" content="ANS Safety Nets, Bengaluru" />
        <link
          rel="canonical"
          href="https://www.anssafetynets.com/monkeysafetynets"
        />
        <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
      </Helmet>
      <HeroSection
        title="Monkey Safety Nets"
        description="Specially designed safety nets to protect people and animals from monkeys."
        bgColor="bg-[#2c3639]"
      />

      <ProductDetails
        title="Why Choose Our Monkey Safety Nets?"
        content="At ANS Safety Nets, we specialize in monkey safety nets designed to ensure the safety of both monkeys and your property. These nets effectively prevent monkeys from entering restricted areas, such as rooftops, gardens, or food storage spaces, while allowing them to move freely in their natural environment. Made from high-strength, durable materials, our monkey safety nets are built to withstand the agility and strength of these curious creatures, ensuring they are safely deterred from entering dangerous areas. Our humane approach prevents harm to the monkeys while safeguarding your property from damage or contamination. Whether you need to protect your home, agricultural land, or commercial spaces, ANS Safety Nets provides a reliable solution to keep monkeys at a safe distance, ensuring both safety and harmony."
        image={main}
      />

      <Images images={[img1, img2, img3]} />

      <Benefits
        benefits={[
          {
            title: "Protection",
            description: "Safeguard your property and animals from monkeys.",
          },
          {
            title: "Durability",
            description: "Designed to withstand harsh outdoor environments.",
          },
          {
            title: "Animal Welfare",
            description:
              "Ensures the safety of monkeys while preventing damage to property.",
          },
        ]}
      />

      <FAQSection
        faqs={[
          {
            question: "Are these nets effective in urban areas?",
            answer:
              "Yes, our nets are designed for use in both urban and rural areas.",
          },
          {
            question: "How long do the nets last?",
            answer:
              "The nets are durable and designed to last several years with proper maintenance.",
          },
        ]}
      />
    </div>
  );
}
